import { motion } from 'framer-motion';
import { Answer, CreateAnswerDto } from '@/types/workerInfo.types';
import { ExperienceInput } from '../inputs/ExperienceInput';
import { NumberInput } from '../inputs/NumberInput';
import { DocumentInput } from '../inputs/DocumentInput';
import { CategoryHeader } from '../common/CategoryHeader';
import { colors, spacing } from '@/theme';

interface ExperienceCategoryProps {
  answers: Answer[];
  progress: number;
  onUpdateAnswer: (questionId: string, data: Partial<CreateAnswerDto>) => Promise<void>;
  saving: boolean;
}

export function ExperienceCategory({ answers, progress, onUpdateAnswer, saving }: ExperienceCategoryProps) {

  const renderInput = (answer: Answer) => {
    const { question, questionId } = answer;
    const commonProps = {
      key: questionId,
      answer,
      onBlur: async (value: any) => {
        try {
          await onUpdateAnswer(questionId, value);
        } catch (error) {
          console.error('Error updating:', error);
        }
      },
      disabled: saving,
    };

    switch (question.type) {
      case 'number':
        return <NumberInput {...commonProps} />;
      case 'experience':
        return <ExperienceInput {...commonProps} />;
      case 'document':
        return <DocumentInput {...commonProps} />;
      default:
        return null;
    }
  };

  const experienceQuestions = answers.filter((a) => a.question.type === 'experience');
  const otherQuestions = answers.filter((a) => a.question.type !== 'experience');

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.25 }}>
      <CategoryHeader
        icon="💼"
        title="Experiencia laboral"
        description="Tu historial profesional y trayectoria."
        progress={progress}
      />

      <div style={{ display: 'flex', flexDirection: 'column', gap: spacing[3] }}>
        {otherQuestions.map((answer, index) => (
          <motion.div
            key={answer.id}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.03 }}
            style={{
              padding: spacing[4],
              borderRadius: 16,
              border: `1px solid ${colors.gray[100]}`,
              backgroundColor: colors.white,
            }}
          >
            {renderInput(answer)}
          </motion.div>
        ))}

        {experienceQuestions.map((answer, index) => (
          <motion.div
            key={answer.id}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 + index * 0.03 }}
            style={{
              padding: spacing[4],
              borderRadius: 16,
              border: `1px solid ${colors.gray[100]}`,
              backgroundColor: colors.white,
            }}
          >
            {renderInput(answer)}
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
